<template>
	<div :id="id" class="cstlayer" :class="{'mod_wrapper': iswrapper}" :is="(!is_relative && !ispreview)?'drag-resizable':'div'" :x="pos.left" :y="pos.top" :w="size.width" :h="size.height|calcheight(is_relative?'':id)" :type="type" :parent="true" :style="[modStyle(mod_param.globalstyle),{'box-sizing': (type=='media')?'content-box':'border-box',left: is_relative?false:`${pos.left}px`,top: is_relative?false:`${pos.top}px`,width: is_relative?false:`${size.width}px`,height: (type == 'webpage')?'100%':((size.height == 'auto')?size.height:`${size.height}px`),'z-index': is_relative?false:pos.zindex}]" @dragging="onDrag" @resizing="onResize" @click.stop="onActivated" @activated="onActivated" @deactivated="onDeactivated">
		<div class="handler handler-top" v-if="! ispreview" v-show="is_active"></div>
		<div class="handler handler-btm" v-if="! ispreview" v-show="is_active">
			<span @mousedown.stop.prevent="layoutResize('bm', $event)" class="btmhandler" v-if="heightResizable && isActive && is_active"></span>
		</div>
		<template v-if="!is_relative && !ispreview">
			<div class="handler handler-right" v-show="is_active"></div>
			<div class="handler handler-left" v-show="is_active"></div>
		</template>
	    <div class="wp_content" @click="layerTap(mod_param.childprop)" :style="{'text-align': mod_param.childprop['text-align']||'left',width: is_relative?'100%': `${size.width}px`,height: is_relative?'100%':`${size.height}px`}">
			<component :is="`wp_${type}`" :param='mod_param.childprop' :children="children" :comp_id="mod_param.id" :class="{'last-placeholder': islast && isContainer}" :isactive="is_active"></component>
	    </div>
	    <template v-if="position=='relative' && !ispreview">
	    	<div class="clear"></div>
			<div class="myhandler">Ξ</div>
	    </template>
		<div v-if="! ispreview" class="removit" @click.stop="rmPlugin">×</div>
		<div v-if="!isContainer && !ispreview" class="masklayer"></div>
	</div>
</template>

<script>
import jGlobal from '@/global';
import DragResizable from '@/components/dragresizable';
import EventBus from '@/common/events';
import Mods from '@/common/mods';

export default 
{
	name: 'module',
	data (){
		return {
		  module_params: this.mod_param,
		  type: this.mod_param.type,
		  isActive: false,
		  layoutResizing: false,
		  layoutHandle: null,
		  heightResizable: false,
		  ispreview: false,
		}
	},
	filters: {
		calcheight (val, layerid){
			if (layerid.length && val == 'auto')
				val = $('#'+layerid).height() || 100
			
			return val
		}
	},
	computed: {
		id (){
			return this.module_params.id
		},
		pos (){
			return {"left": this.module_params.left,"top": this.module_params.top,"zindex": this.module_params.zindex}
		},
		size (){
			let height = this.module_params.height;
			if (this.isContainer) height = 'auto';
			return {"width": this.module_params.width,height}
		},
		is_relative (){
		  return this.position == 'relative'
		},
		iswrapper (){
			return (this.is_relative && !/^form_/i.test(this.type)) ? true : false
		},
		isContainer (){
			const filters = ['freelayout', 'forms'];
			return $.inArray(this.type, filters) > -1 ? true : false
		}
	},
	created (){
		let modname = this.type;
		this.ispreview = jGlobal.isPreview();
		this.$options.components[`wp_${modname}`] = resolve => {
			require.ensure([], require => {
				let reqc = require.context("@/wxplugins", true, /^\.\/.+?\/.+?.vue$/);

	            try {
	            	let loaded = reqc(`./${modname}/${modname}.vue`);
	            	if (loaded) resolve(loaded);
	            	else throw 'not found'
	            } catch (err) {
	            	console.error(`${modname} not found`)
	            }
	        }, 'mod')
		};

		EventBus.$on(`activate_mod_${this.id}`, () => {
			if (modname.startsWith('form_')) return false;
			this.onActivated.apply(this)
			EventBus.$emit("vdr_activated",this.id)
		});

		this.minh = 50;
		this.mouseY = 0;
		this.mouseOffY = 0;
		this.lastMouseY = 0
	},
	mounted (){
		let vm = this;
		// for 'preview'
		if (vm.ispreview) return false;
		// for 'layout'
		if (this.is_relative) {
			window['formel_parentid'] = '';
			$(vm.$el).on('mouseenter', function(e){
				// for '表单子组件'
				let _this_ = e.currentTarget,
				layerid = $(_this_).attr("id"),
				targetid = $(e.target).closest('.cstlayer').attr("id");
				if ($(_this_).hasClass('mod_wrapper')) formel_parentid = layerid;
				if (layerid != targetid) return false;
				if (formel_parentid && targetid != formel_parentid)
					$(`#${formel_parentid}`).trigger('mouseleave', ['foo']);

				$('> .myhandler, > .removit', _this_).show();
				if (! vm.is_active) $('> .handler-top, > .handler-btm', _this_).addClass("hover").show();
				// Show 'layer-name'
				vm.showLayerName(_this_)
			}).on('mouseleave', function(e, type){
				// for '表单子组件'
				let _this_ = e.currentTarget,
				$handler = $('> .handler-top, > .handler-btm', _this_);
				if (!type && $(_this_).attr("id") == formel_parentid) formel_parentid = '';
				else formel_parentid && $(`#${formel_parentid}`).trigger('mouseenter');

				$('> .myhandler, > .removit', _this_).hide();
				$handler.removeClass("hover");
				!vm.is_active && $handler.hide()
			})
		}
		// for 'cstlayer'
		else {
			$(vm.$el).on('mouseenter', function(e){
				e.stopPropagation();
				let $removit = $('> .removit', this), $handler = $('> .handler', this);
				if ($(this).width() >= 60) $removit.css({'border-right': 'none','border-top': 'none','top': '1px'});
				else $removit.css({'border-right': '1px solid #2d8cf0','border-top': '1px solid #2d8cf0','top': '-19px'});

				$('> .removit', this).add($handler).show();
				!$(this).hasClass("active") && $handler.addClass("hover");
				$(this).closest('.mod_wrapper').trigger("mouseleave");
				// Show 'layer-name'
				vm.showLayerName(this)
			}).on('mouseleave', function(e){
				$('> .removit', this).hide();
				let $handler = $('> .handler', this);
				$handler.removeClass("hover");
				!$(this).hasClass("active") && $handler.hide();
				$(this).closest('.mod_wrapper').trigger("mouseenter")
			})
		}

		document.documentElement.addEventListener('mousemove', this.dragMove, true);
		document.documentElement.addEventListener('mouseup', this.dragUp, true)
	},
	beforeDestroy (){
		document.documentElement.removeEventListener('mousemove', this.dragMove, true);
		document.documentElement.removeEventListener('mouseup', this.dragUp, true);
		EventBus.$off(`activate_mod_${this.id}`)
	},
	methods: {
		layerTap (attr){
			let clickobj = attr.modclick || {};
			if (! $.isEmptyObject(clickobj) && 'page' == clickobj.type || 'none') {
				let pgval = (clickobj.param || {}).value || '';
				if (typeof pgval == 'number') {
					location.search = jGlobal.resetSearch({'editor': pgval})
				} else if (/^[a-z_]+$/i.test(pgval)) {
					console.log(pgval, '后期开发...');
					//EventBus.$emit('marketing_redirect', pgval)
				}
			}
		},
		showLayerName (target){
			let $target = $(target),
			modparam = Mods.get_plugin_param($target.attr("type")),
			layername = modparam['_module_name'] || '';
			if (layername.length == 0) return false;
			if (parseFloat($('.wp_content', target).css('width')) < 50) return false;
			
			$('> .handler > #layertip', target).remove();
			let ndstr = Math.min($target.offset().top, $target.position().top) >= 22 ? 'top' : 'btm';
			$(`<span id="layertip">${layername}</span>`).appendTo($(`> .handler-${ndstr}.hover`, target))
		},
		modStyle (bgobj = {}){
			let tmpobj = $.extend(true, {}, bgobj),
			bgimg = tmpobj['background-image'] || 'none';
			if (bgimg != 'none') tmpobj = $.extend({}, tmpobj, {'background-image': `url(${bgimg})`});
			// Add 'px'
			for (let v in tmpobj) {
				let pval = tmpobj[v];
				if (typeof pval == 'number') tmpobj[v] = `${pval}px`
			}
			// for 'preview'
			if (!this.is_relative && this.ispreview) tmpobj['position'] = 'absolute';
			
			return tmpobj
		},
		onResize (x, y, w, h){
			this.module_params.left = parseInt(x);
			this.module_params.top = parseInt(y);
			this.module_params.width = parseInt(w);
			this.module_params.height = parseInt(h)
		},
		onDrag (x, y){
			this.module_params.left = parseInt(x);
			this.module_params.top =parseInt(y)
		},
		onActivated (){
			// for 'preview'
			if (this.ispreview) {
				jGlobal.pagelink(this.module_params.childprop.modclick);
				return false
			}
			this.isActive = true;
			EventBus.$emit('mod_activate', this.id);
			// show 'border'
			$('> .handler', `#${this.id}`).removeClass("hover").show().children('#layertip').remove();
			
			// for 'resize-height'
			let modfields = Mods.get_plugin_param(this.type);
			this.heightResizable = modfields._height_resizable || false;
			
			// Move the module through the arrow keys
			let vm = this, maxwidth = 375;
			if (vm.is_relative) return false;
			$(document).on('keydown.vdrmove', function(e){
				let kycode = e.keyCode;
				switch (kycode) {
					case 37: // '←'
					case 39: // '→'
						let newleft = 0, _left_ = vm.pos.left;
						if (kycode == 37) newleft = Math.max(0, _left_ - 1);
						else newleft = Math.min(maxwidth - vm.size.width, _left_ + 1);
						vm.module_params.left = newleft;
						break;
					case 38: // '↑'
					case 40: // '↓'
						e.preventDefault();
						let newtop = 0, _top_ = vm.pos.top;
						if (kycode == 40) newtop = _top_ + 1;
						else newtop = Math.max(0, _top_ - 1);
						vm.module_params.top = newtop;
						break;
				}
			})
		},
		onDeactivated (){
			this.isActive = false;
			EventBus.$emit('mod_deactivate', this.id);
			// show 'border'
			$('> .handler', `#${this.id}`).hide();
			// Move the module through the arrow keys
			$(document).off('.vdrmove');
			EventBus.$emit("user_behavior", 'edit_plugin')
		},
		rmPlugin (){
			EventBus.$emit('mod_remove', this.id)
		},
		layoutResize (handle, e){
			this.layoutHandle = handle;
			if (e.stopPropagation) e.stopPropagation();
			if (e.preventDefault) e.preventDefault();

			this.layoutResizing = true
		},
		dragMove (e){
			this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
			let diffY = this.mouseY - this.lastMouseY + this.mouseOffY;
			this.mouseOffY = 0;
			this.lastMouseY = this.mouseY;

			let dY = diffY;
			if (! this.layoutResizing) return false;
			let elmH = this.module_params.childprop.height;
		    if (this.layoutHandle.indexOf('b') >= 0) {
				if (elmH + dY < this.minh) this.mouseOffY = (dY - (diffY = this.minh - elmH));
				this.module_params.childprop.height += diffY
		    }
		},
		dragUp (e){
			this.layoutHandle = null;
			this.layoutResizing = false
		}
	},
	props: ['mod_param','position','is_active','children','islast'],
	components: {DragResizable}
}
</script>

<style type="text/css">
.cstalyer {position:absolute;left:0px;top:0px;}
.wp_content {position:relative;}
.mod_wrapper {position:relative;height:150px;}
.cstlayer > .handler-top, .cstlayer > .handler-btm  {position:absolute;width:100%;height:1px;font-size:1px;left:0;z-index:100;}
.cstlayer > .handler-top {top:0;border-top:1px solid #2d8cf0;}
.cstlayer > .handler-top.hover {border-top-style:dashed;}
.cstlayer > .handler-btm {bottom:0;border-bottom:1px solid #2d8cf0;}
.cstlayer > .handler-btm.hover {border-bottom-style:dashed;}
.cstlayer > .handler-right, .cstlayer > .handler-left {position:absolute;width:1px;height:100%;font-size:1px;top:0;z-index:100;}
.cstlayer > .handler-right {right:0;border-right:1px solid #2d8cf0;}
.cstlayer > .handler-right.hover {border-right-style:dashed;}
.cstlayer > .handler-left {left:0;border-left:1px solid #2d8cf0;}
.cstlayer > .handler-left.hover {border-left-style:dashed;}
.myhandler {cursor:move;left:calc(50% - 25px);width:50px;}
.sortghost .myhandler, .sortghost .removit {display:none!important;}
.btmhandler {bottom:-4px;left:50%;margin-left:-4px;cursor:s-resize;-webkit-box-sizing:border-box;box-sizing:border-box;    display:block;position:absolute;width:10px;height:10px;font-size:1px;background:#fff;border:1px solid #2d8cf0;border-radius:10px;z-index:1000;}
.masklayer {background:transparent;position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;z-index:10;}
</style>


// WEBPACK FOOTER //
// module.vue?5bf47c16